<template>
  <div 
    class="spacer-widget"
    :style="spacerStyles"
  ></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { SpacerWidget } from '@/types/pagebuilder'
import { resolveWidgetBackgroundStyle } from '@/utils/backgroundGradient'

interface Props {
  widget: SpacerWidget
}

const props = defineProps<Props>()

const spacerStyles = computed(() => ({
  height: props.widget.height || '2rem',
  ...resolveWidgetBackgroundStyle(props.widget),
  width: '100%',
}))
</script>

<style scoped>
.spacer-widget {
  display: block;
}
</style>